const divModalDocEmployee = {
  uploadSubmitError: 'Aguarde todos os arquivos subirem',
  uploadEmptyFileError: 'Mínimo de 1 arquivo necessário'
};

export default divModalDocEmployee;
